import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { startWith, tap } from 'rxjs/operators';
import { Notification } from './notification';
import { NotificationsService } from './notifications.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tcc-notifications',
  styles: [`
.notifications {
    z-index: 99999;
    position: fixed;
    top: 46px;
    right: 8px;
    width: 350px;
}
`],
  template: `
<div class="notifications">
  <div *ngFor="let n of (notifications$ | async)" class="toast show" [ngClass]="notificationCss(n)" [@notificationBox]>
    <div class="toast-header" *ngIf="n.heading" >
      <strong class="me-auto" [innerHTML]="n.heading"></strong>
      <button type="button" class="ms-2 mb-1 btn-close" aria-label="Close" (click)="removeNotification(n.id)"></button>
    </div>
    <div class="toast-body d-flex flex-row" >
      <div class="flex-grow-1" [ngClass]="n.additionalCss || ''" [innerHTML]="n.message"></div>
      <div class="flex-shrink-1" *ngIf="!n.heading">
        <button type="button"  class="btn-close px-1 py-0" style="margin-top:-.25rem; margin-right: -.25rem;" aria-label="Close"
          [ngClass]="buttonCss(n)"
          (click)="removeNotification(n.id)">
        </button>
      </div>
    </div>
  </div>
</div>
`,
  animations: [
    trigger(
      'notificationBox', [transition(
        ':leave',
        [
          style({ transform: 'translateY(0%)', opacity: 1 }),
          animate('250ms', style({ transform: 'translateY(-100%)', opacity: 0 }))
        ]
      )]
    )
  ],
})
export class NotificationsComponent {

  readonly notifications$ = this.notificationsSvc.notificationsState$;

  constructor(private notificationsSvc: NotificationsService) { }

  /** the time in miliseconds before a notification automatically disappears */
  @Input()
  set defaultDuration(value: number) {
    this.notificationsSvc.defaultDuration = value;
  }
  /**
   * gets the full Class attribute values from the cssClass attribute of a notification
   */
  notificationCss(notification: Notification) {
    const cssClass = notification.cssClass || 'light';
    const textClass = (['light', 'white', 'warning'].indexOf(cssClass) === -1) ? 'text-light' : 'text-dark';
    return `bg-${cssClass} ${textClass}`;

  }

  buttonCss(notification: Notification) {
    const cssClass = notification.cssClass || 'light';
    return `btn-${cssClass}`;
  }
  /**
   * calls remove notification on notificationsSvc
   * @param notificationId the id of the notification to remove
   */
  removeNotification(notificationId: number) {
    this.notificationsSvc.remove(notificationId);
  }

}
